import { UserOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'

import { Creator } from '@/model/creator'
import { getNotificationContent, Notification } from '@/model/notification'
import { User } from '@/model/user'
import { AppDispatch, RootState } from '@/redux'
import { createConversation } from '@/redux/conversation-actions'
import { creatorSelector } from '@/redux/creator-adaptor'
import { activateCreatorTab, addCreatorTab, updateHomeTabFanUserId, UserTabType } from '@/redux/creator-tab-actions'

import FanName from './fan-name'
import { notification } from './message'
import s from './notification-popup.module.css'

const NotificationFanInfo = ({ user, text }: { user: User, text: string }) => (
  <div className={s.NotificationFanInfo} >
    <FanName user={user} />
    <span className={s.NotificationContent}>{text}</span>
  </div>
)

const NotificationCreatorInfo = ({ creator }: { creator: Creator }) => (
  <div className={s.NotificationCreatorInfo}>
    <Avatar
      src={creator.avatarUrl}
      icon={(<UserOutlined />)}
      shape='square'
      size={22}
    />
    <span>{creator.name}</span>
  </div>
)

export interface BaeNotificationProps {
  creatorId: number
  notificationData: Notification
  duration?: number
  rootState?: RootState
  dispatch: AppDispatch
}

export const openBaeNotification = ({
  creatorId,
  notificationData,
  duration = 10,
  rootState,
  dispatch,
}: BaeNotificationProps) => {
  const { id, user } = notificationData
  if (!rootState) return
  const key = `${creatorId}-${id}`
  const creator = creatorSelector.selectById(rootState.creator.creatorEntity, creatorId)
  const conversations = rootState.conversation.conversationsMap[creatorId]

  notification.open({
    key,
    className: `${s.BaeNotification}`,
    message: (<NotificationFanInfo user={user} text={getNotificationContent(notificationData)} />),
    description: (<NotificationCreatorInfo creator={creator} />),
    onClick: async () => {
      const existConversation = conversations?.find(({ id }) => id === user.uid)
      if (!existConversation) {
        await dispatch(createConversation({
          creatorId,
          creatorUserId: creator.onlyFansUserId,
          conversationId: user.uid,
        }))
      }
      const existingCreatorTabItem = rootState.creatorTab.find((item) => creatorId === item.creatorId)
      if (!existingCreatorTabItem) {
        dispatch(addCreatorTab({
          creatorId,
          active: true,
          userTabItems: [],
          activeUserTabType: UserTabType.Home,
          massMassageTabVisible: false,
        }))
      }
      dispatch(activateCreatorTab(creatorId))
      dispatch(updateHomeTabFanUserId({ creatorId, fanUserId: user.id }))
      notification.destroy(key)
    },
    duration,
    showProgress: true,
  })
}